import * as React from 'react';
import { observer } from 'mobx-react';
import useMount from '@src/utils/hooks/use-mount';
import useStore from '@src/utils/hooks/use-store';
import Store from './store';
import Page from '@src/components/page';
import PageSwiper from '@src/components/swiper/page-swiper';
import Navibar from '@src/business-components/navibar';
import { SECTION_CONFIG, kvSectionStore, downloadSectionStore } from './config';
import cx from 'classnames';

const styles = require('./index.less');

const sectionList = Object.values(SECTION_CONFIG).sort((a, b) => a.order - b.order);

const Main = () => {
  const store = useStore(() => new Store());

  store.use();
  useMount(() => {
    kvSectionStore.test = () => {
      alert('test');
    };
    downloadSectionStore.onCopyrightVisibleChange = visible => {
      if (visible) {
        store.footerModal.open();
      } else {
        store.footerModal.close();
      }
    };
  });

  return (
    <Page className={styles.root}>
      <Navibar store={store.navibarStore} />
      {store.activeIndex < 2 && <div className={styles.scrollTips} />}
      <PageSwiper store={store.pageSwiperStore}>
        {sectionList.map(item => (
          <div className={cx(styles.pageItem)} key={item.title}>
            <item.component store={item.store} isActive={item.order === store.activeIndex} />
          </div>
        ))}
      </PageSwiper>
    </Page>
  );
};

export default observer(Main);
